export default __webpack_public_path__ + "static/TwitterButton-ebc1ba4286bed995eefbdb0c36006d33.svg";